import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav7").addClass("active");
var swiper2 = new Swiper(".mySwiper2", {
    slidesPerView: 3,
    spaceBetween: '10.71%',
    direction: "vertical",
    watchSlidesProgress: true,
    breakpoints: {
        320: { //当屏幕宽度大于等于320
            slidesPerView: 3,
            spaceBetween: '10px',
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: '4%',
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: '10.71%',
        }
    },

});

var swiper1 = new Swiper(".mySwiper1", {
    direction: "vertical",
    pagination: {
        el: ".swiper-pagination",
        //自定义分页器样式
        type:"custom",
        renderCustom: function (swiper, current, total) {
            var dangqian = document.querySelector(".dangqian")
            var zongshu = document.querySelector(".zongshu")
            if(current<=9){
                current = "0"+current
            }else{
                current = current
            }
            if(total<=9){
                total = "0"+total
            }else{
            total = total
            }
            dangqian.innerText = current
            zongshu.innerText = total
        }
    },
    navigation: {
        nextEl: ".content .swiper-button-next",
        prevEl: ".content .swiper-button-prev",
    },
    thumbs: {
        swiper: swiper2,
    },
});
